import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "@/requests/hooks/user";
import { COLLECT_HOME_URL, COLLECT_SIGNUP_URL } from "@/utils/const";
import parseQueryString from "@/utils/parseQueryString";
import { getOnboardingUrl } from "@/utils/onboardingManager";

interface IProps {
  children: ReactNode;
}

const OnboardingMiddleware = ({ children }: IProps) => {
  const { pathname, state } = useLocation();
  const { data: user } = useUser();

  if (!user?.activeOnboardingFlow) return <Navigate to={COLLECT_HOME_URL} />;

  if (user?.activeOnboardingFlow === "COMPLY") {
    return children;
  }

  const { origin } = parseQueryString();
  const signupUrl = !!origin
    ? `${COLLECT_SIGNUP_URL}?origin=${origin}`
    : COLLECT_SIGNUP_URL;

  const completedOnboardingScreen = user?.onboardingProgress;

  const nextScreen =
    getOnboardingUrl(completedOnboardingScreen as ICollectOnboardingScreens) ||
    signupUrl;

  if (!!nextScreen && !pathname.endsWith(nextScreen) && !state)
    return <Navigate to={nextScreen} />;

  return children;
};

export default OnboardingMiddleware;
